const Button = ({ children, href, className, onClick }) => (
    <a href={href} className={className} onClick={onClick}>
      {children}
    </a>
  );
  export default Button;